/**
 * This file is a wrapper around the jquery log event interface and is deprecated in favor of @zr/common/frontend/js/log_event
 */


export interface jq {
  // eslint-disable-next-line camelcase
  log_event(eventName: string, callback: () => void): void;
  // eslint-disable-next-line camelcase
  log_event(eventName: string, properties?: Record<string, unknown>, callback?: () => void): void;
}

declare global {
  interface Window {
    $: jq;
    logPageView(fireAgain?: boolean, abTest?: Record<string, unknown>): void;
  }
}

/**
 * Tracks and posts events to both Mixpanel and Periscope.
 *
 * @deprecated use \@zr/common/frontend/js/log_event instead
 *
 * @param {String} eventName Event name.
 * @param {Object} [eventProperties] Event properties.
 * @param {Function} [callback] Function that executes after event is logged.
 */
export default function logEvent(
  eventName: string,
  eventProperties?: Record<string, unknown>,
  callback?: () => void,
): void {
  if (typeof window.$?.log_event === 'undefined') {
    // eslint-disable-next-line no-console
    console.warn('The log_event function is not available. jQuery may not be loaded.');
    return;
  }
  if (eventProperties === undefined && callback !== undefined) {
    window.$.log_event(eventName, callback);
  } else {
    window.$.log_event(eventName, eventProperties, callback);
  }
}

export function logPageView(
  abTest: Record<string, unknown>,
): void {
  window.logPageView(true, abTest);
}
